import React from 'react';

const ErrorFallback = ({ error, resetErrorBoundary }) => {
  return (
    <div className="error-fallback">
      <div className="error-fallback__container">
        <h2>Something went wrong</h2>
        <details style={{ whiteSpace: 'pre-wrap', marginBottom: '1rem' }}>
          <summary>Error details</summary>
          {error.message}
          {error.stack}
        </details>
        <button 
          onClick={resetErrorBoundary}
          className="error-fallback__button"
        >
          Try again
        </button>
      </div>
    </div>
  );
};

export default ErrorFallback;
